/// <reference path="type.type.ts" />

import AxelType from './type.type';

export default class AxelNumber extends AxelType {
  constructor(value) {
    super(value);

    const computedValue = this.computeValue(value);

    if (!isNaN(computedValue)) {
      this._newValue = computedValue;
    } else {
      this.setAsDirty();
    }
  }

  private computeValue(value) {
    // handle null as NaN instead of 0
    let result = value === null ? NaN : Number(value);
    let percent, currency;

    if (isNaN(result)) {
      result = this.findPercent(String(value)) || result;
    }

    if (isNaN(result)) {
      result = this.findCurrency(String(value)) || result;
    }

    return result;
  }

  private findPercent(str) {
    const pattern = /^([-+])?((\d*[,| |.]\d*)*)%$/;
    const result = str.match(pattern);

    return result && result.length ? parseFloat(this.cleanNumStr(result[2])) * 1e-2 : null;
  }

  private findCurrency(str) {
    const pattern = /^\$([-+])?((\d*[,| |.]\d*)*)$/;
    const result = str.match(pattern);

    return result && result.length ? parseFloat(this.cleanNumStr(result[2])) : null;
  }

  private cleanNumStr(str) {
    return str.replace(/\s|,/, '');
  }
}
